import type { ISmsAutoReplySettings } from 'infrastructure/interfaces';

export class SmsAutoReplySettings {
  id: string;
  key: string;
  available: boolean;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;

  constructor(data: ISmsAutoReplySettings) {
    this.id = data.id;
    this.key = data.key;
    this.available = data.available;
    this.createdAt = data.createdAt;
    this.createdBy = data.createdBy;
    this.updatedAt = data.updatedAt;
    this.updatedBy = data.updatedBy;
  }
}
